
import { Routes, Route } from "react-router-dom";
import PublicLayout from "@/layouts/PublicLayout";
import BookingLandingEmpty from "@/pages/booking/BookingLandingEmpty";
import HotelLanding from "@/pages/booking/HotelLanding";
import Availability from "@/pages/booking/Availability";
import GuestInfo from "@/pages/booking/GuestInfo";
import Confirmation from "@/pages/booking/Confirmation";
import BookingStatus from "@/pages/booking/BookingStatus";
import BookingPropertyGuard from "@/modules/booking/components/BookingPropertyGuard";
import PaymentSuccess from "@/pages/booking/PaymentSuccess";

import PaymentRoutes from "@/modules/payment/routes";

export default function PublicRoutes() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        {/* Index: แสดงหน้า Landing ว่าง + โลโก้ */}
        <Route path="/" element={<BookingLandingEmpty />} />

        {/* /booking ไม่มี propcode -> หน้า landing empty */}
        <Route path="/booking" element={<BookingLandingEmpty />} />

        {/* /booking/:propcode -> แสดงหน้า booking เฉพาะเมื่อ propcode ถูกต้อง */}
        <Route
          path="/booking/:propcode"
          element={
            <BookingPropertyGuard>
              <HotelLanding />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/availability"
          element={
            <BookingPropertyGuard>
              <Availability />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/guest"
          element={
            <BookingPropertyGuard>
              <GuestInfo />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/confirmation"
          element={
            <BookingPropertyGuard>
              <Confirmation />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/status"
          element={
            <BookingPropertyGuard>
              <BookingStatus />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/payment/success"
          element={
            <BookingPropertyGuard>
              <PaymentSuccess />
            </BookingPropertyGuard>
          }
        />

        <Route
          path="/booking/:propcode/payment/*"
          element={
            <BookingPropertyGuard>
              <PaymentRoutes />
            </BookingPropertyGuard>
          }
        />
      </Route>
    </Routes>
  );
}
